import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=56296ebe&scoped=true&"
import script from "./Viewer.vue?vue&type=script&lang=js&"
export * from "./Viewer.vue?vue&type=script&lang=js&"
import style0 from "./Viewer.vue?vue&type=style&index=0&id=56296ebe&lang=scss&scoped=true&"
import style1 from "./Viewer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56296ebe",
  null
  
)

export default component.exports